import { render } from "./StepConfirmPage.vue?vue&type=template&id=5da7d66e"
import script from "./StepConfirmPage.vue?vue&type=script&lang=js"
export * from "./StepConfirmPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__